<router-outlet></router-outlet> <!-- Primary router-outlet for top-level modules -->
<!--<div id="header">-->
  <!-- Keep existing header content -->
<!--</div>

<div id="angular-root">
  <router-outlet></router-outlet>--> <!-- Primary router-outlet for top-level modules -->
<!--</div>

<div id="wrapper">
  <router-outlet name="wrapper"></router-outlet>--> <!-- Secondary outlet for ServicerModule -->
<!--</div>

<footer class="footer">-->
  <!-- Keep existing footer content -->
<!--</footer>-->
